// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';

interface Props {
  active: boolean;
  toggle: () => void;
  text: string;
}

const ToggleText: FC<Props> = ({ active, toggle, text }) => (
  <Text
    onClick={toggle}
    weight={active ? 'bolder' : 'normal'}
    p="md"
    pt={5}
    pb={5}
    sx={(theme) => ({
      cursor: 'pointer',
      borderRadius: 10,
      backgroundColor: active
        ? theme.colorScheme === 'dark'
          ? theme.colors.dark[4]
          : theme.colors.lightBlue[0]
        : 'inherit',
      color: active
        ? theme.colorScheme === 'dark'
          ? theme.colors.blue[1]
          : theme.colors.blue[4]
        : theme.colorScheme === 'dark'
        ? '#E5E5E5'
        : '#1A1A1A',
    })}
  >
    {text}
  </Text>
);

export default ToggleText;
